import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";

class TotalField extends Component {
  renderInput() {
    const { element_value } = this.props;

    return <input readOnly={true} value={element_value} />;
  }

  componentDidUpdate(prevProps) {
    if(prevProps.element_value !== this.props.element_value) {
      this.props.onChange(
        this.props.repeatingForm === undefined
          ? false
          : this.props.repeatingForm,
        this.props.element_id,
        this.props.element_value
      )
    }
  }

  render() {
    const { element_prompt, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <div>{this.renderInput()}</div>
        </Form.Field>
      </div>
    );
  }
}

TotalField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TotalField;



// WEBPACK FOOTER //
// ./src/components/TotalField/index.js